import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

interface RadioButtonJsxProps {
  attrs?: {
    disabled?: boolean;
    focused?: boolean;
    icon?: string;
    selected?: boolean;
    theme?: string;
  };
}

export class RadioButton extends Component<EmptyObj, RadioButtonJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<RadioButtonJsxProps['attrs']> {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      focused: `boolean`,
      icon: `string`,
      selected: `boolean`,
      theme: {type: `string`, default: `primary`},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }
}

export const RadioButtonEl = defineAndMakeJsxFactory<RadioButtonJsxProps>(`mp-radio-button`, RadioButton);
export const RadioButtonReact = panel2react<RadioButtonJsxProps>(`mp-radio-button`, RadioButton);
